import { VendorRebateCategoryProgramPermissions } from '../../../components/Vendor/RebateCategories';

export function RebateCategoryProgramPermissions() {
  return <VendorRebateCategoryProgramPermissions />;
}
